// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__2d4KG","list":"Pagination_list__2XZrG","arrowActive":"Pagination_arrowActive__1jl41","arrowDisabled":"Pagination_arrowDisabled__24DDi"};